export default __webpack_public_path__ + "static/media/sunhotel-logo.f019c8fd.svg";